/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Existing_Subtitle_LinkInputs */

const en_existing_subtitle_link = /** @type {(inputs: Existing_Subtitle_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`from an idea`)
};

const id_existing_subtitle_link = /** @type {(inputs: Existing_Subtitle_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dari ide`)
};

/**
* | output |
* | --- |
* | "from an idea" |
*
* @param {Existing_Subtitle_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const existing_subtitle_link = /** @type {((inputs?: Existing_Subtitle_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Existing_Subtitle_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_existing_subtitle_link(inputs)
	return en_existing_subtitle_link(inputs)
});